var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vld-parent"},[_c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.loading=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }